import { useLocation } from "react-router-dom";

import type { PortalUser } from "@/app/models";
import { PORTAL_USER_TYPE } from "@/app/models";
import { CoachingSuccessScreenAlert } from "./sections";
import { PatientSuccessScreenAlert } from "./sections/patient-success-screen-alert";

export const SuccessScreen = () => {
  const location = useLocation();

  const portalUserType = location.state as PortalUser["type"];

  if (portalUserType === PORTAL_USER_TYPE.COACHING) {
    return <CoachingSuccessScreenAlert />;
  }

  return <PatientSuccessScreenAlert />;
};
